var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03479 8.13057C1.10847 6.92173 1.14531 6.31731 1.45854 5.73597C1.74473 5.20481 2.2923 4.6896 2.83988 4.43625C3.43921 4.15897 4.12617 4.15897 5.50008 4.15897C6.01215 4.15897 6.26819 4.15897 6.5162 4.11709C6.76138 4.07568 7.00046 4.00396 7.22795 3.90356C7.45806 3.80201 7.67181 3.66107 8.09932 3.3792L8.31825 3.23484C10.8612 1.55816 12.1327 0.719814 13.2001 1.08405C13.4047 1.15388 13.6028 1.25469 13.7797 1.37901C14.7024 2.02747 14.7725 3.53617 14.9127 6.55358C14.9646 7.67085 15 8.62708 15 9.15897C15 9.69085 14.9646 10.6471 14.9127 11.7644C14.7725 14.7818 14.7024 16.2905 13.7797 16.9389C13.6028 17.0632 13.4047 17.1641 13.2001 17.2339C12.1327 17.5981 10.8612 16.7598 8.31825 15.0831L8.09932 14.9387C7.67181 14.6569 7.45806 14.5159 7.22795 14.4144C7.00046 14.314 6.76138 14.2423 6.5162 14.2008C6.26819 14.159 6.01215 14.159 5.50008 14.159C4.12617 14.159 3.43921 14.159 2.83988 13.8817C2.2923 13.6283 1.74473 13.1131 1.45854 12.582C1.14531 12.0006 1.10847 11.3962 1.03479 10.1874C1.01299 9.82975 1 9.48137 1 9.15897C1 8.83657 1.01299 8.48818 1.03479 8.13057Z",
    stroke: "#9EA0A2",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.15918C19.5 3.15918 21 4.95918 21 9.15918C21 13.3592 19.5 15.1592 19.5 15.1592",
    stroke: "#9EA0A2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.15918C17.5 6.15918 18 7.05918 18 9.15918C18 11.2592 17.5 12.1592 17.5 12.1592",
    stroke: "#9EA0A2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumMute);
export default __webpack_public_path__ + "static/media/volumMute.6dca2fc9cf48bcbf30c703c320eb2150.svg";
export { ForwardRef as ReactComponent };